<template>
    <div class="lang-change">
      <select class="has-value lang-select"
      :class="{
        'dark-lang-select': isDarkBGRouteSet
      }" 
      v-model="selectedLang" @change="changeLang">
        <option value="en">
          {{ $t('footer_sections_languages_english') }}
        </option>
        <option value="fr">
          {{ $t('footer_sections_languages_french') }}
        </option>
        <option value="de">
          {{ $t('footer_sections_languages_german') }}
        </option>
        <option value="ru">
          {{ $t('footer_sections_languages_russian') }}
        </option>
        <option value="es">
          {{ $t('footer_sections_languages_spanish') }}
        </option>
        <option value="nl">
          {{ $t('footer_sections_languages_dutch') }}
        </option>
        <option value="it">
          {{ $t('footer_sections_languages_italian') }}
        </option>
        <option value="pt">
          {{ $t('footer_sections_languages_portuguese') }}
        </option>
        <option value="ar">
          {{ $t('footer_sections_languages_arabic') }}
        </option>
      </select>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        selectedLang: this.$i18n.locale,
        whiteBgRoutes: ['products'],
        darkBgRoutes: ['profile'],
      };
    },
    watch: {
      '$i18n.locale'(newLocale) {
        this.selectedLang = newLocale;
      }
    },
    computed: {
        currentRoute() {
            return this.$route.name;
        },
        isWhiteBackgroundSet() {
            return this.whiteBgRoutes.includes(this.currentRoute);
        },
        isDarkBGRouteSet() {
            return this.darkBgRoutes.includes(this.currentRoute);
        },
    },
    methods: {
      changeLang() {
        if (this.selectedLang !== this.$i18n.locale) {
          this.$i18n.locale = this.selectedLang;
        }
      }
    }
  };
  </script>
  
  <style scoped lang="scss">
  .lang-change {
    margin: 0.2rem 0;
    font-family: "Nunito-Regular";
    font-size: 14px;
  }
  .lang-select {
    padding: 5px;
    font-size: 14px;
    border: 1px solid #ccc;
    border-radius: 6px;
    background-color: #fff;
    color: #020076;
    
    @media (max-width: 830px ) {
      font-size: 11px; 
    }
  }
  .dark-lang-select {
    background-color: #020076 !important;
    color: white !important;
  }
</style>
  